//@flow
import { connect } from 'react-redux';
import LostAndStolen from './LostAndStolen';
import { hasActiveSubscriptions } from '../../modules/Subscriptions';
import type { StateType } from '../../modules/reducers';
import type { StateProps } from './LostAndStolen';

const mapStateToProps = (state: StateType): StateProps => ({
  hasActiveSubscriptions: hasActiveSubscriptions(state),
});

export default connect(mapStateToProps)(LostAndStolen);
